import {useTranslation} from "react-i18next";
import React, {useState} from "react";
import {Wrapper} from "./styles"
import {useContextHospi} from "../../context/ContextHospi";
import Modal from "../Modal";
import {DialogWrapper} from "../containers";
import {Button, TextPlain, TitleH2} from "../generic";
import {UserAPI} from "../../API/userApi";
import {API_USERS, HOST_PROFILE_ROUTE} from "../../utils/constants";
import {useNavigate} from "react-router-dom";
import ReactDOM from "react-dom";


export const VerificationBanner = () => {

    const { userProfile, updateProfile } = useContextHospi();
    const [open] = useState<boolean>(userProfile ? userProfile.verification_status !== 'verified': false)
    const [requested, setRequested] = useState<boolean>(userProfile ? userProfile.verification_status === 'verifying': false)
    const { t, i18n } = useTranslation('host');
    const [ showModal, setShowModal ] = useState<number>(0)
    const navigate = useNavigate();

    interface IPortal {
        container: HTMLElement,
    }

    const ModalPortal = (props: IPortal) => {
        return ReactDOM.createPortal(
            (
                <Modal isShow={!!showModal} handleClose={() => setShowModal(0)}>
                    <DialogWrapper>
                        <TitleH2>{t(`hostProfile.requestVerified.title`)}</TitleH2>
                        <TextPlain
                            style={{
                                whiteSpace: "pre-line",
                                wordBreak: "break-word",
                                marginTop: "24px",
                            }}
                        >
                            {showModal === 10 &&
                                t(`hostProfile.requestVerified.text`, {
                                    joinArrays: "\n\n",
                                })}
                            {showModal === 20 &&
                                t(`hostProfile.requestVerified.message`, {
                                    joinArrays: "\n\n",
                                })}
                        </TextPlain>

                        <div className="buttons">
                            <Button normal onClick={() => setShowModal(0)}>
                                {showModal === 10 &&
                                    t(`hostProfile.requestVerified.buttonSkip`)}
                                {showModal === 20 &&
                                    t(`hostProfile.requestVerified.buttonCancel`)}
                            </Button>
                            <Button main onClick={sendRequest}>
                                {showModal === 10 &&
                                    t(`hostProfile.requestVerified.buttonRequest`)}
                                {showModal === 20 &&
                                    t(`hostProfile.requestVerified.buttonGoEditProfile`)}
                            </Button>
                        </div>
                    </DialogWrapper>
                </Modal>
            ),
            props.container
        )
    }

    const sendRequest = async () => {
        if (
            userProfile?.user_type === "host" &&
            userProfile.verification_status === "unverified"
        )
            if (userProfile.is_profile_complete) {
                const response = await UserAPI.create(
                    API_USERS + `${userProfile?.user_id}/request-verification`,
                    {}
                );

                if (response.hasOwnProperty("status")) return;
                updateProfile(response);
                setRequested(true)
            } else navigate(`/${i18n.language}${HOST_PROFILE_ROUTE.slice(5)}`);
        setShowModal(0);
    };

    return (
        <>
        <Wrapper open={open}>
            { requested ? (
                <>
                <div>
                    <p>{t('popupVerification.requested')}</p>
                </div>
                </>) : (
                <>
                <div>
                    <p>{t('popupVerification.text')}</p>
                    <Button main onClick={() => {setShowModal(userProfile?.is_profile_complete ? 10 : 20)}}>{t('popupVerification.button')}</Button>
                </div>
                </>) }
        </Wrapper>
    {showModal !== 0 && (
        <ModalPortal container={document.getElementById('root') as HTMLElement}/>
    )}
        </>
    );
}
